import { create } from "zustand";

type PopupStore = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  content: React.ReactNode | null;
  setContent: (content: React.ReactNode) => void;
};

export const useHelpPopupStore = create<PopupStore>((set) => ({
  isOpen: false,
  setIsOpen: (isOpen: boolean) => set({ isOpen: isOpen }),
  content: null,
  setContent: (content: React.ReactNode) => set({ content: content }),
}));
